'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _CartStore = require('../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _Constants = require('../Constants');

var Constants = _interopRequireWildcard(_Constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SIGNUP_BUTTON_SPIN_TEXT = "Please wait...";

var SIGN_UP_BUTTON_TEXT = "Sign Up";
var SIGN_UP_VPWD_ERROR = "Verify password does not match !";

var SignUpComponent = function (_React$Component) {
    _inherits(SignUpComponent, _React$Component);

    function SignUpComponent(props) {
        _classCallCheck(this, SignUpComponent);

        var _this = _possibleConstructorReturn(this, (SignUpComponent.__proto__ || Object.getPrototypeOf(SignUpComponent)).call(this, props));

        _this.handleInput = function (e) {
            // console.log(e);
            // this is where we'll call the phoneNumberFormatter function
            var formattedPhoneNumber = Utils.convertStringToPhoneNumberFormat(e.target.value);

            _this.setState({
                phoneNumber: formattedPhoneNumber,
                signUpError: ""
            });
        };

        _this.submitSignUpForm = function (e) {
            e.preventDefault();

            var self = _this;

            self.setState({
                signUpError: null
            });

            var username = "";
            var password = "";
            var vPassword = "";
            var regex = /^[a-zA-Z0-9][a-zA-Z0-9 ]*$/;

            var name = _this.name.value.replaceAll(/\s+/g, ' ').trim();
            if (Utils.isEmpty(name)) {
                _this.setState({
                    signUpError: "Please enter your name."
                });
                return;
            } else {

                if (!regex.test(name)) {

                    _this.setState({
                        signUpError: "Numbers & Special Characters not Allowed like (@ * . # ! $ ^ &)",
                        isProcessActive: false
                    });

                    return;
                }
            }

            var phone = "";
            if (_this.state.isPhoneNumberRequired) {
                //validate
                var phoneNo = Utils.removeNonNumber(_this.state.phoneNumber);
                if (phoneNo.length !== 10) {
                    _this.setState({
                        signUpError: "Phone number must be of 10 digits."
                    });
                    return;
                }

                phone = phoneNo;
            } else {
                phone = "0000000000";
            }

            username = _this.susername.value;
            password = _this.spassword.value;
            vPassword = _this.vspassword.value;

            var email = username.trim();
            if (Utils.isEmpty(email)) {

                _this.setState({
                    signUpError: "Please enter your email address."
                });

                return;
            } else {

                email.replaceAll(/\s+/g, ' ');
                var regex = Constants.EMAIlREGEXP;

                if (!regex.test(email)) {
                    _this.setState({
                        signUpError: "Special characters are not allowed in the email address."
                    });
                    return;
                }
            }

            if (password.length > 0) {
                if (password !== vPassword) {
                    _this.setState({
                        signUpError: SIGN_UP_VPWD_ERROR
                    });
                    return;
                }
            }

            Utils.showSpinner();

            var u = new _parse2.default.User({
                username: username,
                password: password,
                name: name,
                phoneNumber: phone,
                email: username
            });
            u.signUp().then(function (currentUser) {
                Utils.updateUserAcl();
                Utils.hideSpinner();
                self.setState({
                    signUpError: null
                });

                self.props.informSignUpStatus(currentUser);
            }, function (error) {
                console.log(JSON.stringify(error));
                Utils.hideSpinner();
                self.setState({
                    signUpError: error.message
                });
            });
        };

        _this.state = {
            signUpError: null,
            isProcessActive: false,
            isPhoneNumberRequired: true,
            phoneNumber: ''
        };
        return _this;
    }

    _createClass(SignUpComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.name.focus();

            var orderType = _CartStore2.default.getOrderType();

            if (_MainStore2.default.isLocationForDineInOnly() || orderType == "DineIn") {
                var askPhone = _CartStore2.default.isDineInPhoneRequired();
                this.setState({ isPhoneNumberRequired: askPhone });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: "row" },
                _react2.default.createElement(
                    'div',
                    { className: "col-lg-12 col-md-12" },
                    _react2.default.createElement(
                        'div',
                        { className: 'login d-flex align-items-center py-2' },
                        _react2.default.createElement(
                            'div',
                            { className: "container" },
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'mx-auto no-gutter py-2 col-md-12 col-lg-12' },
                                    _react2.default.createElement(
                                        'form',
                                        { id: 'signupform', role: 'form', onSubmit: this.submitSignUpForm },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'form-group mb-2' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'name', className: 'mb-1' },
                                                'Name'
                                            ),
                                            _react2.default.createElement('input', {
                                                ref: function ref(input) {
                                                    return _this2.name = input;
                                                },
                                                type: 'text', id: 'inputName',
                                                placeholder: 'Name',
                                                className: "form-control"
                                            })
                                        ),
                                        this.state.isPhoneNumberRequired ? _react2.default.createElement(
                                            'div',
                                            { className: 'form-group mb-2' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'inputEmail', className: 'mb-1' },
                                                'Phone Number'
                                            ),
                                            _react2.default.createElement('input', {
                                                ref: function ref(input) {
                                                    return _this2.phone = input;
                                                },
                                                type: 'tel', id: 'phoneNumber',
                                                placeholder: 'Phone Number',
                                                onChange: function onChange(e) {
                                                    return _this2.handleInput(e);
                                                },
                                                value: this.state.phoneNumber,
                                                className: "form-control"
                                            })
                                        ) : null,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'form-group mb-2' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'susername', className: 'mb-1' },
                                                'Email address'
                                            ),
                                            _react2.default.createElement('input', {
                                                ref: function ref(input) {
                                                    return _this2.susername = input;
                                                },
                                                name: 'username',
                                                type: 'email', id: 'inputEmail', placeholder: 'Email address', className: "form-control" })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'form-group mb-2' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'password', className: 'mb-1' },
                                                'Password'
                                            ),
                                            _react2.default.createElement('input', {
                                                ref: function ref(input) {
                                                    return _this2.spassword = input;
                                                },
                                                type: 'password', id: 'inputPassword', placeholder: 'Password', className: "form-control" })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'form-group mb-4' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'vpassword', className: 'mb-1' },
                                                'Verify password'
                                            ),
                                            _react2.default.createElement('input', {
                                                ref: function ref(input) {
                                                    return _this2.vspassword = input;
                                                },
                                                type: 'password', id: 'verifyPassword', placeholder: 'Verify Password', className: "form-control" })
                                        ),
                                        this.state.signUpError ? _react2.default.createElement(
                                            'div',
                                            { id: 'signup-alert', className: 'alert alert-danger col-sm-12' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'row centered errors' },
                                                _react2.default.createElement('i', { className: 'glyphicon glyphicon-remove' }),
                                                ' ',
                                                this.state.signUpError
                                            )
                                        ) : null,
                                        _react2.default.createElement(
                                            'button',
                                            {
                                                className: "btn mt-30 btn-lg" + " custom-btn-outline-primary btn-block btn-login text-uppercase font-weight-bold mb-2",
                                                onClick: this.submitSignUpForm },
                                            'Sign Up'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'text-center pt-2' },
                                            'Already have an account? ',
                                            _react2.default.createElement(
                                                'a',
                                                { className: 'text-danger cursor-pointer', onClick: this.props.showLoginBox },
                                                'Sign In'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'text-center pt-2' },
                                            _react2.default.createElement(
                                                'span',
                                                null,
                                                '  By creating an account, you are agreeing to the'
                                            ),
                                            ' ',
                                            _react2.default.createElement(
                                                'a',
                                                { href: 'http://www.freshbytes.io/terms', target: '_blank' },
                                                'Terms of Service'
                                            ),
                                            ' and ',
                                            _react2.default.createElement(
                                                'a',
                                                { href: 'http://www.freshbytes.io/privacy', target: '_blank' },
                                                'Privacy Policy'
                                            ),
                                            ' of FreshBytes.'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SignUpComponent;
}(_react2.default.Component);

exports.default = SignUpComponent;


//////////////////
// WEBPACK FOOTER
// ./src/components/login/SignUp.jsx
// module id = 538
// module chunks = 0